module.exports = __webpack_public_path__ + "static/media/weight.ff5cfe4b.svg";